// biome-ignore-all lint/suspicious/noExplicitAny: PDF renderer types are untyped third-party
import { db } from '@app/icare/client/db'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import type { PatientFormIdType } from '@app/icare/db/schema/form/PatientFormCommon'
import { getFormHandler } from '@app/icare/documents/config'
import { PdfViewer } from '@pkg/ui/document/PdfViewer'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'

// Dev route for rendering react-pdf. HMR does not work reliably for react-pdf,
// so we force a full page reload on hot updates affecting PDF-related code.
if (import.meta.hot && typeof window !== 'undefined') {
  // Reload when this module updates
  import.meta.hot.accept(() => window.location.reload())
  // Reload when any PDF-related module updates (documents, pdf viewer, react-pdf)
  import.meta.hot.on('vite:beforeUpdate', (payload: any) => {
    try {
      const shouldReload = payload?.updates?.some((u: any) => {
        const p: string = u?.path ?? ''
        return p.includes('/src/documents') || p.includes('@react-pdf')
      })
      if (shouldReload) {
        window.location.reload()
      }
    } catch (_e) {
      // Fallback: if anything goes wrong, do nothing special
    }
  })
}

export const Route = createFileRoute('/pdf/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  const { data } = useSuspenseQuery(localQueryEntityOptions(id as PatientFormIdType))
  const doc = useMemo(() => getFormHandler(data.type).documents?.default?.document, [data.type])

  if (!doc) {
    return (
      <div>
        No Document for
        {data.type}
      </div>
    )
  }

  return (
    <div className="h-full w-full">
      <PdfViewer className="w-full h-screen border border-gray-200 rounded" document={doc} db={db} formId={id} />
    </div>
  )
}
